import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { AuthGuardService } from '@core/services/authGuard.service';
import { AuditorhomeModule } from 'app/components/auditorhome/auditorhome.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AuthRoutingModule
  ],
  providers: [AuthGuardService]
  //{ provide: AuthGuardService}
  //]

})
export class AuthModule { }
